<div class="carousel-container">
  <!-- Main Carousel Container -->
  <div
    class="carousel-wrapper position-relative overflow-hidden rounded-4 shadow-lg"
  >
    <div
      class="carousel-track d-flex"
      [style.transform]="'translateX(-' + currentSlide * 100 + '%)'"
    >
      <div
        *ngFor="let slide of slides"
        class="carousel-slide flex-shrink-0 w-100"
      >
        <div class="card border-0 rounded-4 overflow-hidden h-100">
          <div
            class="slide-content position-relative text-white d-flex align-items-center justify-content-center"
            [ngClass]="slide.bgColor"
            style="min-height: 400px"
          >
            <!-- Background Image -->
            <div
              *ngIf="slide.hasBackgroundImage && slide.backgroundImage"
              class="slide-background position-absolute w-100 h-100"
              [style.background-image]="'url(' + slide.backgroundImage + ')'"
            ></div>
            <div class="slide-overlay position-absolute w-100 h-100"></div>

            <!-- Background Pattern for slides without images -->
            <div
              *ngIf="!slide.hasBackgroundImage"
              class="slide-pattern position-absolute w-100 h-100"
            >
              <div class="pattern-circle pattern-1 position-absolute"></div>
              <div class="pattern-circle pattern-2 position-absolute"></div>
            </div>

            <div
              class="slide-text position-relative text-center p-4 p-lg-5"
              style="z-index: 10"
            >
              <div class="slide-icon mb-4" [ngClass]="slide.iconColor">
                <i
                  class="bi"
                  [ngClass]="slide.icon"
                  style="font-size: 3rem"
                ></i>
              </div>
              <h3
                class="slide-title display-5 fw-bold mb-4 text-white text-shadow"
              >
                {{ slide.title }}
              </h3>
              <p class="slide-description lead mb-4 text-white text-shadow">
                {{ slide.description }}
              </p>
              <button
                class="btn btn-light btn-lg px-4 py-2 fw-bold shadow-lg text-kemis-blue slide-button"
              >
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Arrows -->
    <button
      class="btn carousel-nav carousel-nav-prev position-absolute top-50 translate-middle-y start-0 ms-3"
      (click)="goToPrevious()"
      aria-label="Previous slide"
    >
      <i class="bi bi-chevron-left"></i>
    </button>

    <button
      class="btn carousel-nav carousel-nav-next position-absolute top-50 translate-middle-y end-0 me-3"
      (click)="goToNext()"
      aria-label="Next slide"
    >
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>

  <!-- Slide Indicators -->
  <div class="carousel-indicators d-flex justify-content-center mt-4 gap-2">
    <button
      *ngFor="let slide of slides; let i = index"
      class="indicator rounded-circle border-0"
      [class.indicator-active]="i === currentSlide"
      (click)="goToSlide(i)"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
    ></button>
  </div>

  <!-- Auto-play indicator -->
  <div class="autoplay-indicator d-flex justify-content-center mt-3 d-none">
    <div class="autoplay-status d-flex align-items-center gap-2">
      <div
        class="status-dot rounded-circle"
        [class.status-active]="isAutoPlaying"
      ></div>
      <span class="small text-muted">{{
        isAutoPlaying ? "Auto-playing" : "Paused"
      }}</span>
    </div>
  </div>
</div>
